/**
 * Token budget usage API client (§7g / 7f backend).
 *
 * Returns `{ tokensUsedToday, dailyTokenBudget, tokenResetDate }`.
 * The endpoint is read-only — it mirrors the lazy reset semantics
 * in memory without persisting, so polling is safe and cheap.
 */

import { request } from "./api.js";

export const getUsage = () => request("/api/usage");
